{
	"version": "2.2.0",
	"arclive": "http://localhost:3000/api",
	"papi": "https://dev-az.tez-papi.tezzeract.ai/v1",
	"demo": false,
	"cognito": {
		"authDomain": "https://cognito-development.patrocinium.com",
		"lookupDomain": "https://domain-lookup-development.patrocinium.com",
		"redirectUri": "http://localhost:3000"
	},
	"pulse": {
		"url": "https://live-dev.patrocinium.com/api/pulse/integration"
	},
	"insight": {
		"url": "https://live-dev.patrocinium.com/insight"
	},
	"plugins": [
		"markers",
		"twitterpublic",
		"demo",
		"whiteboarding",
		"measurement-tool"
	],
	"default": {
		"bing": {
			"key": "AtdO-JFj_FvPbiYANkZKkwD5460mBUhjVm3S2MV8h6KgPs6fG_VQ8fgSFjwhPYTz"
		}
	},
	"allianzAccessList": {
		"emails": [
			"cherrykm+2@gmail.com",
			"cherrykm+1@gmail.com",
			"cherrykm@gmail.com",
			"kcherry@patrocinium.com",
			"jsouth@patrocinium.com"
		]
	},
	"demoUser": [
		"kevin.patro.admin",
		"jsouth.patrocinium.com"
	],
	"cesium": {
		"imageryProviderViewModels": [
			{
				"name": "Mapbox Satellite",
				"iconUrl": "Widgets/Images/ImageryProviders/mapboxSatellite.png",
				"tooltip": "Mapbox Satellite \nhttps://www.mapbox.com/about/maps/",
				"providers": [
					{
						"instantiate": true,
						"call": "MapboxStyleImageryProvider",
						"options": {
							"styleId": "satellite-v9",
							"scaleFactor": true,
							"accessToken": "pk.eyJ1IjoicmFqamFueWFkYXYyMDI0IiwiYSI6ImNtczdidml4MTAyM3ozOXBsdDB4NXhwbXcifQ.9XHlhQaO2CJ4E5V6Bc4AAQ"
						}
					}
				]
			},
			{
				"name": "Mapbox Satellite with Streets",
				"iconUrl": "Widgets/Images/ImageryProviders/mapboxSatellite.png",
				"tooltip": "Mapbox Satellite with Streets \nhttps://www.mapbox.com/about/maps/",
				"providers": [
					{
						"instantiate": true,
						"call": "MapboxStyleImageryProvider",
						"options": {
							"styleId": "satellite-streets-v11",
							"scaleFactor": true,
							"accessToken": "pk.eyJ1IjoicmFqamFueWFkYXYyMDI0IiwiYSI6ImNtczdidml4MTAyM3ozOXBsdDB4NXhwbXcifQ.9XHlhQaO2CJ4E5V6Bc4AAQ"
						}
					}
				]
			},
			{
				"name": "Mapbox Streets",
				"iconUrl": "Widgets/Images/ImageryProviders/mapboxStreets.png",
				"tooltip": "Mapbox Streets \nhttps://www.mapbox.com/about/maps/",
				"providers": [
					{
						"instantiate": true,
						"call": "MapboxStyleImageryProvider",
						"options": {
							"styleId": "streets-v11",
							"scaleFactor": true,
							"accessToken": "pk.eyJ1IjoicmFqamFueWFkYXYyMDI0IiwiYSI6ImNtczdidml4MTAyM3ozOXBsdDB4NXhwbXcifQ.9XHlhQaO2CJ4E5V6Bc4AAQ"
						}
					}
				]
			}
		],
		"selectedImageryProviderViewModel": 1,
		"accessToken": "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJqdGkiOiJiNzEyZTYwZi03NjRiLTRhNjUtYTc0YS01MDYxY2Y3MzcwODAiLCJpZCI6NDAzMDYxLCJpYXQiOjE3NzM0MDUwNTN9.R695Ik3EwqapXuq3keZtANOpJz66jrHMQsOXRSycb_M"
	},
	"incidentAttributeVisualizer": {
		"leaflet": {
			"map": {
				"options": {
					"attributionControl": false
				}
			},
			"tileLayer": {
				"url": "http://{s}.tile.osm.org/{z}/{x}/{y}.png",
				"options": {
					"maxZoom": 23,
					"maxNativeZoom": 19,
					"attribution": "Map data &copy; <a href=\"http://www.openstreetmap.org/copyright\">OpenStreetMap</a>, Imagery &copy; <a href=\"http://mapbox.com\">Mapbox</a>",
					"id": "mapbox.streets",
					"reuseTiles": true
				}
			}
		}
	},
	"floorAttributeVisualizer": {
		"leaflet": {
			"map": {
				"options": {
					"attributionControl": false
				}
			},
			"tileLayer": {
				"url": "http://{s}.tile.osm.org/{z}/{x}/{y}.png",
				"options": {
					"maxZoom": 23,
					"maxNativeZoom": 19,
					"attribution": "Map data &copy; <a href=\"http://www.openstreetmap.org/copyright\">OpenStreetMap</a>, Imagery &copy; <a href=\"http://mapbox.com\">Mapbox</a>",
					"id": "mapbox.streets",
					"reuseTiles": true
				}
			}
		}
	},
	"adhocMessageWindow": {
		"leaflet": {
			"map": {
				"options": {
					"attributionControl": false
				}
			},
			"tileLayer": {
				"url": "http://{s}.tile.osm.org/{z}/{x}/{y}.png",
				"options": {
					"maxZoom": 23,
					"attribution": "Map data &copy; <a href=\"http://www.openstreetmap.org/copyright\">OpenStreetMap</a>, Imagery &copy; <a href=\"http://mapbox.com\">Mapbox</a>",
					"id": "mapbox.streets",
					"reuseTiles": true
				}
			}
		}
	},
	"buildingTilesService": {
		"loadTile": {
			"url": "https://d.data.osmbuildings.org/0.2/anonymous/tile/<%= z %>/<%= x %>/<%= y %>.json"
		}
	},
	"setIntervalForApiCall": 2000
}
